define('gameday-language/gameday-language',['require','exports','module','./dictionary','mustache-language/mustache-language'],function(require,exports,module){
    var dictionary = require( "./dictionary" );
    return require( "mustache-language/mustache-language" );
});
